import fetcher from "../../helper/fetcher"
import React, { useEffect, useState } from 'react'
import { useSnackbar } from '../../context/SnackBarContext';
import { ManageInvoiceUI } from '../../features/Inventory/ManageInvoiceUI/ManageInvoiceUI';

export const ManageInvoice = () => {
    const { showSuccess, showError } = useSnackbar();
    const [refetch, setRefetch] = useState(1)
    const [invoices, setInvoices] = useState({
        results: [],
        page: 0,
        limit: 0,
        totalPages: 0,
        totalResults: 0,
    });
    const [isLoading, setLoading] = useState(false);
    const [state, setState] = useState({
        id: null,
        isModalOpen: false,
        query: "",
    });
    const [params, setParams] = useState({
        page: 1,
        limit: 20,
    });
    const setPage = (page) => {
        setParams({ ...params, page: page });
    };

    const updateState = (data) => {
        setState((prevState) => {
            const newState = { ...prevState, ...data };
            return newState;
        });
    };

    const handleSearchInvoice = (val) => {
        fetcher
            .get(
                `/inventory/invoice/get_all_invoice?query=${state.query}&page=${val == undefined ? params.page : val}&limit=${params.limit}`
            )
            .then((res) => {
                setLoading(true);
                // console.log(res.data.totalPages, "kkkkkkk");
                setInvoices({
                    ...res.data,
                });
            })
            .catch((err) => {
                //console.log(err, "errrrr");
            })
            .finally(() => {
                setLoading(false);
            });
    };


    useEffect(() => {
        handleSearchInvoice();
    }, [refetch, params]);


    const handleDeleteInvoice = () => {
        if (!state.id) return;
        updateState({ isLoading: true });
        fetcher
            .delete(`/inventory/invoice/delete_invoice/${state.id}`)
            .then((res) => {
                showSuccess("Deleted successfully");
            })
            .catch((error) => {
                showError("Some Error Occured");
            })
            .finally(() => {
                setRefetch((pre) => pre + 1)
                updateState({ isLoading: false, isModalOpen: false });
            });
    };

    return (
        <ManageInvoiceUI
            invoices={invoices}
            updateState={updateState}
            isLoading={isLoading}
            state={state}
            setPage={setPage}
            params={params}
            setRefetch={setRefetch}
            handleDeleteInvoice={handleDeleteInvoice}
            handleSearchInvoice={(val) => handleSearchInvoice(val)}
        />
    )
}
